import React, { useReducer } from "react";
import axios from "axios";
import { Form, Field } from "react-final-form";

import URL, { headers } from "../../common/variables";
import { RegistrationReducer } from "./RegistrationReducer";
import validate from "./validationForm";
import { saveToken } from "../../common/functions";

const Registration = () => {
    const initialState = {
        isError: false,
        isErrorMessage: [],
    };
    const [state, dispatch] = useReducer(RegistrationReducer, initialState);

    const onSubmit = (values) => {
        axios
            .post(`${URL}/rest-auth/registration/`, values, { headers })
            .then((response) => {
                dispatch({ type: "IS_ERROR_REMOVED" });
                const { key } = response.data;

                saveToken(key);

                location.reload();
            })
            .catch((error) => {
                if (error.response) {
                    const obj = error.response.data;
                    const arrErrors = Object.keys(error.response.data).map(
                        (key) => obj[key]
                    );
                    dispatch({ type: "IS_ERROR_ACTIVE", message: arrErrors });
                }
            });
    };

    const showErrors = () => (
        <div className="mt-3 mb-4 text-danger">
            {state.isErrorMessage.map((txt, pos) => (
                <div className="mt-3" key={pos}>
                    {txt}
                </div>
            ))}
        </div>
    );

    return (
        <div className="login">
            <Form
                onSubmit={onSubmit}
                validate={validate}
                render={({ handleSubmit, form, submitting }) => (
                    <form onSubmit={handleSubmit}>
                        <Field name="username">
                            {({ input, meta }) => (
                                <div className="mb-4">
                                    <input
                                        {...input}
                                        autoComplete="off"
                                        className="form-control rounded-0"
                                        type="text"
                                        placeholder="Usuario"
                                    />
                                    {meta.error && meta.touched && (
                                        <div className="mt-1 mb-4 text-danger">
                                            <small>{meta.error}</small>
                                        </div>
                                    )}
                                </div>
                            )}
                        </Field>

                        <Field name="email">
                            {({ input, meta }) => (
                                <div className="mb-4">
                                    <input
                                        {...input}
                                        autoComplete="off"
                                        className="form-control rounded-0"
                                        type="text"
                                        placeholder="Correo electrónico"
                                    />
                                    {meta.error && meta.touched && (
                                        <div className="mt-1 mb-4 text-danger">
                                            <small>{meta.error}</small>
                                        </div>
                                    )}
                                </div>
                            )}
                        </Field>

                        <Field name="password1">
                            {({ input, meta }) => (
                                <div className="mb-4">
                                    <input
                                        {...input}
                                        className="form-control rounded-0"
                                        type="password"
                                        placeholder="Contraseña"
                                    />
                                    {meta.error && meta.touched && (
                                        <div className="mt-1 mb-4 text-danger">
                                            <small>{meta.error}</small>
                                        </div>
                                    )}
                                </div>
                            )}
                        </Field>

                        <Field name="password2">
                            {({ input, meta }) => (
                                <div className="mb-4">
                                    <input
                                        {...input}
                                        className="form-control rounded-0"
                                        type="password"
                                        placeholder="Repite contraseña"
                                    />
                                    {meta.error && meta.touched && (
                                        <div className="mt-1 mb-4 text-danger">
                                            <small>{meta.error}</small>
                                        </div>
                                    )}
                                </div>
                            )}
                        </Field>

                        {/* Form button */}
                        <button
                            type="submit"
                            disabled={submitting}
                            className="btn btn-lg btn-block bg-warning mt-4 mb-2"
                        >
                            {submitting ? "Enviando..." : "Enviar"}
                        </button>

                        {state.isError && showErrors()}
                    </form>
                )}
            />
        </div>
    );
};

export default Registration;
